/* @flow */

'use strict';

exports.__esModule = true;
var getStateKey = function getStateKey(elementKey /*: ?string*/) /*: string*/ {
  return elementKey === null || elementKey === undefined ? 'main' : elementKey.toString();
};

exports['default'] = getStateKey;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/radium/lib/get-state-key.js
 ** module id = 85
 ** module chunks = 0
 **/